import { useEffect, useState } from "react";
import paymentService from "../../services/paymentService";

const useChecks = ( country ) => {
    const [checks, setChecks] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getFromServer = async () => {
            setLoading(true);
            paymentService
                .GetChecks({ pageSize: 50, pageNumber: 1, country })
                .then(res => setChecks(res))
                .finally(() => setLoading(false))
        }

        if (country)
            getFromServer();
    }, [country])

    return {
        checks,
        loading
    }
}
export default useChecks;